import _createClass from "@babel/runtime/helpers/createClass";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _isNativeReflectConstruct from "@babel/runtime/helpers/isNativeReflectConstruct";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import _wrapNativeSuper from "@babel/runtime/helpers/wrapNativeSuper";
import _objectSpread from "@babel/runtime/helpers/objectSpread2";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
import hook from "mibaby-common/util/hook";
import { useMemo } from "react";

/**
 * Add validation from uiSchema "ui:validate" props to formProps. You get the
 * form data value for the field and the usual error handler, and can either push
 * your error to the error handler, or return a error message, or throw a
 * @see ValidationError.
 */
export function useValidation(formProps) {
  return useMemo(function () {
    var uiSchema = formProps.uiSchema,
      validate = formProps.validate;
    if (!uiSchemaHasValidate(uiSchema)) return formProps;
    return _objectSpread(_objectSpread({}, formProps), {}, {
      validate: hook(validate, function (data, errors) {
        return validateUiSchema(uiSchema, data, errors);
      })
    });
  }, [formProps]);
}

/**
 * Recursively validate form data based on "ui:validate" functions in the uiSchema.
 */
export function validateUiSchema(schema, data, errors) {
  for (var key in schema) {
    if (key === "ui:validate") {
      try {
        var msg = schema[key](data, errors);
        if (msg) errors.addError(msg);
      } catch (e) {
        if (!(e instanceof ValidationError)) throw e;
        errors.addError(e.message);
      }
    } else if (key in errors) {
      validateUiSchema(schema[key], data === null || data === void 0 ? void 0 : data[key], errors[key]);
    }
  }
  return errors;
}

/**
 * Recursively check if the uiSchema contains any "ui:validate" functions.
 */
export function uiSchemaHasValidate(schema) {
  if (!schema || typeof schema !== "object") return false;
  if (schema["ui:validate"]) return true;
  for (var key in schema) {
    if (key.startsWith("ui:")) continue;
    if (uiSchemaHasValidate(schema[key])) return true;
  }
  return false;
}

/**
 * Custom error class for form validation errors.
 */
export var ValidationError = /*#__PURE__*/function (_Error) {
  function ValidationError() {
    _classCallCheck(this, ValidationError);
    return _callSuper(this, ValidationError, arguments);
  }
  _inherits(ValidationError, _Error);
  return _createClass(ValidationError);
}(/*#__PURE__*/_wrapNativeSuper(Error));
//# sourceMappingURL=validate.js.map